import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=583fb34c&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"
import style0 from "./TableComponent.vue?vue&type=style&index=0&id=583fb34c&prod&scoped=true&lang=css"
import style1 from "./TableComponent.vue?vue&type=style&index=1&id=583fb34c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583fb34c",
  null
  
)

export default component.exports